export default __webpack_public_path__ + "static/media/rogo.526f1672.gif";